import { normalizeKey } from '../../shared/verteoffice/exports/helpers/helpers'

export { normalizeKey }

export const DEFAULT_WORKLOG_MAX_HOURS = 2

/**
 * Resolves the maximum hours allowed for a worklog row, using a lookup built
 * from domain extras.max_hours (see buildActivityMaxHoursLookup).
 *
 * Resolution order:
 *  1. activity_objective normalized name → lookup
 *  2. specific_activity normalized name → lookup
 *  3. Default: DEFAULT_WORKLOG_MAX_HOURS (2)
 */
export function getMaxHoursForWorklogActivity(
  lookup: Record<string, number>,
  activityObjective?: string | null,
  specificActivity?: string | null
): number {
  if (activityObjective) {
    const v = lookup[normalizeKey(activityObjective)]
    if (v !== undefined) return v
  }
  if (specificActivity) {
    const v = lookup[normalizeKey(specificActivity)]
    if (v !== undefined) return v
  }
  return DEFAULT_WORKLOG_MAX_HOURS
}

export function normalizeSpecificActivity(specificActivity?: string | null): string {
  const raw = typeof specificActivity === 'string'
    ? specificActivity
      .trim()
      .replace(/\s*-\s*/g, '-')
      .replace(/\s+/g, ' ')
    : ''
  return raw ? normalizeKey(raw) : ''
}
